<template>
  <div class="root">
    <div v-if="!$root.loaded" class="loading">
      <h1>Loading</h1>
      <img src="../assets/loading.gif" alt="">
    </div>
    <div v-else class="kit-details">
      <div class="kit-navigation">
          <a class="back-button" @click="$router.go(-1)"> Back </a>
      </div>
      <div class="kit-details-wrapper">
        <div class="kit-details-header">
          <h1>{{ kit.product }}</h1>
          <h3>{{ kit.name }}</h3>
        </div>
        <div class="links">
          <span v-if="kit.website"><a  :href="kit.website" target="_blank" @click.stop>Website</a> | </span>
          <a v-if="kit.instructions" :href="kit.instructions" target="_blank" @click.stop>Instructions</a>
          <a v-else :href="kit.distributorInfo.website" target="_blank" @click.stop>Please Contact {{kit.distributorInfo.name}} for Instructions</a>
        </div>
        <div class="kit-details-content">
          <div class="kit-details-container ratings">
            <div class="kit-details-block inline">
              <div class="kit-details-info">
                <h4 class="kit-details-title">Ease Of Use:</h4>
                <span> {{$root.easeOfUseDescriptors[kit.easeOfUse - 1].rating}}</span>
                <p>Descriptor to evaluate include; {{$root.easeOfUseDescriptors[kit.easeOfUse - 1].description}}</p>
              </div>
              <div class="kit-details-info">
                <h4 class="kit-details-title">Level of Training:  </h4>
                  <span> {{$root.levelOfTrainingDescriptors[kit.levelOfTraining - 1].rating}}</span>
                <p>Recommended level of training; {{$root.levelOfTrainingDescriptors[kit.levelOfTraining - 1].description}}</p>
              </div>
            </div>
          </div>
          <div class="kit-details-block">
            <h4> Distributor Information </h4>
            <div class="kit-details-info">
              <p>{{ kit.distributorInfo.name }}</p>
              <p>
                <span v-for="(country, index) in kit.distributorInfo.country" :key="index">
                  {{ country }}<span v-if="index !== kit.distributorInfo.country.length - 1">,</span>
                </span>
              </p>
              <p v-for="(website, index) in kit.distributorInfo.website" :key="index">
                <a v-if="index === 0" :href="website" target="_blank" @click.stop>Visit Distributor Website</a>
                <a v-else :href="website" target="_blank" @click.stop>Visit Alternate Distributor Website
                  <span v-if="kit.distributorInfo.website.length > 2">{{index}}</span>
                </a>
              </p>
            </div>
          </div>
          <div class="kit-details-block">
            <h4>Suggested questions to ask the distributor about the product (other than price and availability)</h4>
            <div class="kit-details-info">
              <h4 class="kit-details-title">Broad questions</h4>
              <ul class="list">
                <!-- <li v-for="question in $root.distributorQuestions" :key="question.id">{{ question.question }}</li> -->
                <li>What is the level of technical support offered by the supplier?</li>
                <li>Are there other tests that can be carried out on the instruments needed for this assay?</li>
                <li>What is the timeline for receiving it post-order? </li>
                <li>Is a stock kept in the country?</li>
                <li>Try and understand as much as you can about disposal of the kits and associated materials. If you are not equipped with the necessary equipment or correct disposal facilities, then it can be quite messy. </li>
              </ul>
            </div>
            <div class="kit-details-info">
              <h4 class="kit-details-title">More technical questions (may not be relevant for every test kit)</h4>
              <ul class="list">
                <!-- <li v-for="question in $root.distributorQuestions" :key="question.id">{{ question.question }}</li> -->
                <li>Can you use a generic enrichment broth, or would you need to buy a broth from the manufacturer?</li>
                <li>How many tests can you run in one cycle/run?</li>
                <li>Are there different incubation times for different sample types/matrices?</li>
                <li>Is a stock kept in the country?</li>
                <li>What is the enrichment incubation temperature?</li>
              </ul>
            </div>
          </div>
          <div class="kit-details-container">
            <div class="kit-details-block">
              <div class="kit-details-info">
                <h4 class="kit-details-title">Pathogens: </h4>
                <span class="kit-details-data">
                  <span v-for="pathogen in kit.pathogensInfo" :key="pathogen.id">
                    {{ pathogen.name }}</span>
                </span>
              </div>
            </div>
            <div class="kit-details-block">
              <div class="kit-details-info">
                <h4 class="kit-details-title">Kit Usage: </h4>
                  <span class="kit-details-data">
                    <span v-if="kit.laboratory"> Laboratory</span>
                    <span v-if="kit.inHouse"> In House</span>
                  </span>
              </div>
            </div>
            <div class="kit-details-block">
              <div class="kit-details-info">
              <h4 class="kit-details-title">Test Material: </h4>
                <span class="kit-details-data">
                  <span v-if="kit.environmental"> Environmental</span>
                  <span v-if="kit.food"> Food</span>
                </span>
              </div>
            </div>
          </div>
          <div class="kit-details-container">
            <div class="kit-details-block">
              <div class="kit-details-info">
                <h4 class="kit-details-title">Turn Around Time: </h4>
                <span class="kit-details-data">
                  <span> {{kit.turnaroundTime}}</span>
                </span>
              </div>
            </div>
            <div class="kit-details-block">
              <div class="kit-details-info">
                <h4 class="kit-details-title">Sampling Type: </h4>
                  <span v-for="samplingType in kit.samplingTypes" :key="samplingType.id" class="kit-details-data">
                    <span v-if="samplingType.name"> {{ samplingType.name }}</span>
                  </span>
              </div>
            </div>
          <div class="kit-details-block">
              <div class="kit-details-info">
                <h4 class="kit-details-title"> Validation: </h4>
                <span v-for="validation in kit.kitValidationStandards" :key="validation.id" class="kit-details-data">
                  <span v-if="validation.name"> {{ validation.name }}</span>
                </span>
              </div>
            </div>
          </div>
          <hr style="margin: 25px 0">
          <template v-for="(value, index) in kit">
            <div v-if="checkProperty(index) " :key="index" class="kit-grid info">
              <div class="kit-details-info" >
                <h4 class="kit-details-title"> {{ formatIndex(index) }}: </h4>
                <span class="kit-details-data"> {{ formatValue(value) }} </span>
              </div>
            </div>
          </template>
          <a class="back-button" @click="$router.go(-1)"> Back </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '../mixins/mixins.vue'

export default {
  name: 'KitDetails',
  mixins: [mixins],
  data () {
    return {
      kitID: this.$route.query.id,
      arr: [],
      start: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    kit () {
      if (this.$root.loaded && this.kitID !== undefined) {
        return this.$root.kits.find(kit => kit.id === this.kitID)
      } else {
        return null
      }
    }
  },
  methods: {
    checkArr () {
      var self = this
      var index = [1, 3, 2]
      if (this.arr.length === 3 && this.start !== true) {
        var result = this.arr.every(function (val, i) {
          if (val === index[i]) {
            return true
          } else {
            self.arr.splice(0)
            return false
          }
        })
        this.start = result
      } else {
        this.start = false
      }
    }
  }
}
</script>

<style>

</style>
